import { envFlags } from '@thoughtspot/env-flags';
import { FEATURE_FLAG_NAMES, isFeatureEnabled, } from '@thoughtspot/feature-service';
import DOMPurify from 'dompurify';
export const getLDFlagsFromEventData = (flags) => {
    const result = {};
    flags.forEach((flag) => {
        const sanitizedFlag = DOMPurify.sanitize(flag);
        if (Object.values(FEATURE_FLAG_NAMES).includes(sanitizedFlag)) {
            const LDFlagValue = isFeatureEnabled(sanitizedFlag, {
                urlParamValue: envFlags.getValue(sanitizedFlag),
            });
            result[sanitizedFlag] = {
                flagId: sanitizedFlag,
                flagValue: LDFlagValue,
            };
        }
    });
    return result;
};
//# sourceMappingURL=utils.js.map